import { Button, toast } from '@berky/ui'
import { Copy } from 'lucide-react'

export function FeedbackReference({
  reference,
  id,
  management = true,
}: {
  reference: string
  id: string
  management?: boolean
}) {
  async function copyReference() {
    try {
      const path = management ? '/feedback/' : '/mein-feedback/'
      const url = new URL(`${path}${id}`, window.location.origin)
      await navigator.clipboard.writeText(`${reference} · ${url.href}`)
      toast.success('Kennung und Link kopiert')
    } catch {
      toast.error('Kennung und Link konnten nicht kopiert werden', {
        description: 'Bitte kopieren Sie die Kennung und die Adresse aus dem Browser.',
      })
    }
  }

  return (
    <span className="inline-flex flex-wrap items-center gap-2">
      <span className="font-medium tabular-nums">{reference}</span>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        aria-label={`Kennung und Link zu ${reference} kopieren`}
        onClick={(event) => {
          event.stopPropagation()
          void copyReference()
        }}
        onKeyDown={(event) => event.stopPropagation()}
      >
        <Copy aria-hidden="true" />
        Kopieren
      </Button>
    </span>
  )
}
